<template>
  <div class="create">
    <div class="form">
      <button v-on:click="createList" type="button" class="send"><img src="../assets/images/action.png"/></button>
      <input v-model="name" :placeholder="$t('notification.new_list_title')" />
      <p v-if="successMessage == true" class="message_success">{{$t('notification.list_create')}}</p>
      <p v-if="errorMessag  == true" class="message_success"> </p>
      <p class="message_error" :class="error"> {{errorMessage}}</p>
    </div>
  </div>
</template>

<script>

import Players from '../parse/models/Players'
import WishList from '../parse/models/WishList'
import { bus } from '../main'

export default {
  name: 'create',
  props: {
    idPlayer: String,
    userl: Object
  },
  components: {
  },
  data () {
    return  {
      name: "",
      successMessage: false,
      errorMessag: false,
      errorMessage: "", 
      error: false
    }
  },
  created(){

    bus.$on('disable-list', (value) => {
      this.selected = value
    });
  },
  methods:{
    
    createList(id) {

      if(this.name == ""){
        this.error = true
        this.errorMessage = this.$t('notification.new_list_title')
        return
      }
            
      const data = this.$parse.User.current()

      if( this.idPlayer !=  ''){
        const params = {
          nameList: this.name,
          playerId: this.idPlayer,
        }

        WishList.saveList(params)
        .then((user) => this.successMessage = true)
        .catch(error => this.errorMessag = true)
      } else {
        
        const params = {
          nameList: this.name,
        }

        WishList.saveListJust(params)
        .then((user) => this.reload())
        .catch(error => this.errorMessag = true)
      }
     

      this.errorMessage = "" 
      this.error = false
      this.name = ""

    },
    reload(){
      this.successMessage = true
      setTimeout(() => (window.location.reload()), 2000);
    },
    addToList(id){
      this.playerName = localStorage.namePlayer
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .create{
    background: #000;
    color: #fff;
    transition: all 0.5s;
    border-top: 1px solid rgb(128, 128, 128);
  }
  
  .form{
    margin-top: 15px;
  }

  .form img{
    width: 20px;
    margin-right: 10px;
  }

  .send{
    background: #000;
    color: #fff;
    border: none;
    font-family: 'plain regular', arial;
  }

  input{
    background: #000;
    color: #fff;
    border: none;
    font-family: 'plain regular', arial;
    width: 300px;
    font-style: italic;
    display: inline;
  }

  .message_success{
    float: right;
    margin-right: 16px;
  }
  
  .message_error{
    margin-top: 15px;
    color: red;
    max-height: 50px;
    transition: all 0.5s;
  }

  .message_error_active{
    max-height: auto;
  }

</style>
